module.exports = __webpack_public_path__ + "static/img/whats_included.bb75faa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whats_included.png
// module id = KDKG
// module chunks = 1